import React from 'react';

/**
 * A hook that returns true on the first render of a component and false on all subsequent renders.
 *
 * @since 12.2.0
 */
function useIsFirstRender() {
  const isFirstRender = React.useRef(true);
  React.useEffect(() => {
    isFirstRender.current = false;
  }, []);
  return isFirstRender.current;
}

export { useIsFirstRender };
